<template>
  <v-dialog
    v-model="show"
    max-width="640"
  >
    <v-card class="product-group-edit-form-dialog" :loading="isLoading ? 'secondary' : false">
      <v-card-title class="pb-4" style="word-break: keep-all;">
        {{ isNewProductGroup ? 'Skapa produktgrupp' : 'Redigera produktgrupp' }}
      </v-card-title>
      <v-card-text>
        <v-container v-if="!!editedProductGroup">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedProductGroup.name"
                label="Namn"
                counter="50"
                outlined
                :error-messages="nameErrorMessages"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <v-select
                v-model="editedProductGroup.account_id"
                :items="accountItems"
                label="Intäktskonto"
                outlined
                item-value="id"
                item-text="label"
                :error-messages="accountErrorMessages"
              >
                <template v-slot:item="{ item }">
                  <div class="d-flex justify-space-between align-center" style="width: 100%;">
                    <span>{{ item.label }}</span>
                    <span class="ml-4 grey--text text--darken-1">{{ item.taxLabel }}</span>
                  </div>
                </template>
                <template v-slot:selection="{ item }">
                  <span>{{ item.label }}</span>
                  <span class="ml-2 grey--text text--darken-1">({{ item.taxLabel }})</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-subheader class="">Produkttyp</v-subheader>
              <v-chip-group
                v-model="editedProductGroup.product_type"
                color="secondary"
                mandatory
              >
                <v-chip
                  v-for="productTypeItem in productTypeItems"
                  :key="productTypeItem.value"
                  :value="productTypeItem.value"
                  outlined
                >
                  {{ productTypeItem.text }}
                </v-chip>
              </v-chip-group>
              <div v-if="productTypeErrorMessages.length > 0" class="v-messages error--text text-caption pl-3">
                {{ productTypeErrorMessages[0] }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-btn
          color="error"
          text
          @click="show = false"
          :disabled="isLoading"
        >
          Avbryt
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          @click="saveProductGroup"
          :loading="isLoading"
        >
          {{ isNewProductGroup ? 'Skapa produktgrupp' : 'Spara ändringar' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductGroupFormDialog',
  data: () => ({
    hardValidation: false
  }),
  computed: {
    ...mapState(
      {
        accounts: state => state.product.productGroupFormDialog.accounts
      }
    ),
    show: {
      get () {
        return this.$store.state.product.productGroupFormDialog.show
      },
      set (value) {
        this.$store.commit('product/SET_SHOW_PRODUCT_GROUP_FORM_DIALOG', value)
      }
    },
    isLoading: function () {
      return this.$store.state.product.productGroupFormDialog.isLoading
    },
    isNewProductGroup: function () {
      return this.editedProductGroup && !this.editedProductGroup.id
    },
    editedProductGroup: {
      get () {
        return this.$store.state.product.productGroupFormDialog.editedProductGroup
      },
      set (value) {
        this.$store.commit('product/SET_EDITED_PRODUCT_GROUP', value)
      }
    },
    accountItems: function () {
      return this.accounts.map(account => ({
        id: account.id,
        label: `${account.account_number} ${account.name}`,
        taxLabel: account.tax ? `${account.tax.rate}% moms` : ''
      }))
    },
    productTypeItems: function () {
      return [
        { text: 'Varor', value: 'goods' },
        { text: 'Tjänster', value: 'services' }
      ]
    },
    nameErrorMessages: function () {
      if (!this.editedProductGroup) {
        return []
      }
      const name = this.editedProductGroup.name
      if (name && name.length > 50) {
        return ['Max 50 tecken']
      } else if (this.hardValidation && (!name || name.trim().length === 0)) {
        return ['Ange ett namn']
      }
      return []
    },
    accountErrorMessages: function () {
      if (!this.editedProductGroup) {
        return []
      }
      if (this.hardValidation && !this.editedProductGroup.account_id) {
        return ['Välj ett konto']
      }
      return []
    },
    productTypeErrorMessages: function () {
      if (!this.editedProductGroup) {
        return []
      }
      if (this.hardValidation && !this.editedProductGroup.product_type) {
        return ['Välj en produkttyp']
      }
      return []
    }
  },
  methods: {
    saveProductGroup: function () {
      this.hardValidation = true
      if (!this.editedProductGroup) {
        return
      }
      if (!this.editedProductGroup.name || this.editedProductGroup.name.trim().length === 0) {
        return
      }
      if (!this.editedProductGroup.account_id) {
        return
      }
      if (!this.editedProductGroup.product_type) {
        return
      }
      this.$store.dispatch('product/saveProductGroup')
    }
  },
  watch: {
    show: function (val) {
      if (!val) {
        this.hardValidation = false
      }
    }
  }
}
</script>
